<mat-toolbar class="editing-toolbar">
  <span>Editing: {{ currentProvider?.name || 'New provider' }}</span>

  <span class="spacer"></span>

  <!-- TODO: Allow deleting a section -->
  <button mat-raised-button class="tools-button" (click)="saveForm()" [disabled]="saveButtonDisabled">
    <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
    <span>Save</span>
  </button>
</mat-toolbar>

<form [formGroup]="providerForm" class="dataset-form">
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" placeholder="Name">
  </mat-form-field>

  <div class="logo">

    <div class="actions">
      <mat-form-field class="input">
        <mat-label>New logo file</mat-label>
        <ngx-mat-file-input [formControl]="logoControl" accept="image/*"></ngx-mat-file-input>
      </mat-form-field>

      <button mat-raised-button (click)="clearNewLogoField()" [disabled]="newLogoControlPristine">Reset new logo</button>
      <button mat-raised-button (click)="removeExistingLogo()" [disabled]="!hasExistingLogo">Remove existing logo</button>
    </div>

    <div class="preview">
      <ng-container *ngIf="logoSource; else noImageTemplate">

        <img [src]="logoSource" />
      </ng-container>
    </div>
  </div>
</form>


<ng-template #noImageTemplate>
  <div class="placeholder">
    No logo set
  </div>
</ng-template>
